import type { App, Directive } from 'vue'
import { router } from '@/router'
import { useTrackerStore } from '@/store'

export function install(app: App) {
  const trackerStore = useTrackerStore()
  const trackDirective: Directive<HTMLElement, Entity.RoleType | Entity.RoleType[]> = {
    mounted(el, binding) {
      el.addEventListener(
        'click',
        (e) => {
          const href = el.getAttribute('href')
          let toData = {}
          if (href) {
            const resolved = router.resolve(href)

            toData = {
              toTitle: resolved.meta.title,
              toFullPath: resolved.fullPath,
            }
          }

          const currentRoute = router.currentRoute.value
          const fromData = {
            referrerTitle: currentRoute.meta.title,
            referrerFullPath: currentRoute.fullPath,
          }
          e.stopPropagation()
          /* type: 表示eventClassCode，data: 表示eventContent， public： 表示是否是公共部分 */
          let resValue
          // 用于获取动态数据 用法 v-track="() => ({ type: '输入框查询1', data: search.searchText })"
          if (typeof (binding.value) === 'function') {
            resValue = binding.value()
          }
          // 用于获取对象字面量数据 用法 v-track="{ type: '输入框查询1', searchText: 111 }"
          else {
            resValue = binding.value
          }
          // trackerStore.updateReferrer()
          // console.log(el);
          const type = el.localName
          let eventClassCode = null
          let eventCategoryCode = null
          let eventClass = null
          let eventCategory = null

          if (typeof resValue === 'string' || resValue?.type) {
            const _domType = typeof resValue === 'string' ? resValue : resValue?.type
            const mapping = TrackEventFlatMap[_domType]
            if (mapping) {
              eventClassCode = mapping.eventClassCode
              eventCategoryCode = mapping.eventCategoryCode
              eventClass = mapping.eventClass
              eventCategory = mapping.eventCategory
            }
          }
          else {
            eventClassCode = (() => {
              if (type === 'button' || el.className.includes('n-tabs'))
                return TrackEventData.event_ElementClick.eventClassCode
              if (type === 'a')
                return TrackEventData.event_MenusBrowsing.eventClassCode
              if (el.className.includes('n-input-group-label'))
                return TrackEventData.event_ComponentOperation.eventClassCode
              return null
            })()
            eventCategoryCode = (() => {
              if (type === 'a')
                return TrackEventData.event_MenusBrowsing.categories.Page_Jumpto.eventCategoryCode
              if (type === 'button')
                return TrackEventData.event_ElementClick.categories.Button.eventCategoryCode
              // 如果内容是未搜索框标签
              if (el.className.includes('n-input-group-label')) {
                return TrackEventData.event_ComponentOperation.categories.Input.eventCategoryCode
              }
              if (el.className.includes('n-tabs')) {
                return TrackEventData.event_ElementClick.categories.Label.eventCategoryCode
              }
              return null
            })()
            eventClass = eventClassCode ? TrackEventData[eventClassCode].eventClass : '未定义'

            eventCategory = eventCategoryCode ? TrackEventFlatMap[eventCategoryCode].eventCategory : '未定义'
          }
          const baseData = {
            eventClassCode, // 事件名称编码
            eventClass, // 事件名称
            eventCategoryCode, // 事件类型编码
            eventCategory, // 事件类型
            eventContent: (resValue?.public && resValue?.data ? `会员中心公共区-${resValue.data}` : resValue?.data)
              ?? (resValue?.public && el.textContent?.trim() ? `会员中心公共区-${el.textContent.trim()}` : el.textContent?.trim())
              ?? null, // 事件内容 or 数据
            productName: resValue?.productName ?? null,
            eventOtherContent: resValue?.eventOtherContent ?? el.textContent?.trim() ?? null,
          }
          const data = resValue?.type === 'Page_Jumpto' || (type === 'a' && resValue?.type !== 'SuperLink')
            ? { ...baseData, ...toData }
            : { ...baseData, ...fromData }

          // 调用全局上报方法
          trackerStore.reportByDirectives({
            ...data,
          })
        },
        false,
      )
    },
  }
  app.directive('track', trackDirective)
}
